<template>
  <div :class="cls_name" v-if="navs && navs.length > 0">
    <div
      :class="{'nav-item':true,'choose':idx === choose}"
      v-for="(item,idx) in navs"
      @click="click_item(item,idx)"
    >
      {{item.title}}
      <div class="choose_tag"></div>
    </div>
  </div>
</template>
<script>
import { openLink } from "../../tools/mgtv/link";
import click_handler from "../../tools/mgtv/click";
export default {
  name: "NavBar",
  props: {
     parent_name: {
      type: String,
      default: ""
    },
    navs: {
      type: Array,
      default: () => {
        return [
          {
            title: "标题1",
            handler: () => {
              console.log("标题1");
              //回调中
            }
          },
          {
            title: "标题2",
            handler: () => {
              console.log("标题2");
            }
          },
          {
            title: "标题3",
            handler: () => {
              console.log("标题3");
            }
          },
          {
            title: "标题4",
            handler: () => {
              console.log("标题4");
            }
          }
        ];
      }
    },
    choose: {
      //目前选中第几个
      type: Number,
      default: 0
    }
  },
  data: function() {
    return {
    };
  },
  methods: {
    click_item(item, idx) {
      click_handler(`${this.parent_name}-导航条-${item.title}`, () => {
        if (idx === this.choose) {
          return;
        }
        setTimeout(() => {
          if (item.handler) {
            item.handler();
          }
        }, 50);
      });
    }
  },
  mounted() {},
  computed: {
    cls_name() {
      if (this.navs.length > 4) {
        return "cls_navbar cls_navbar_scroll";
      } else {
        return "cls_navbar";
      }
    }
  }
};
</script>


<style lang="stylus" scoped>
 @import "../../share/mixins.styl"
 .cls_navbar
    position relative
    width 7.5rem
    display flex
    align-items: center
    height .81rem
    // box-shadow:0px 0.04rem 0.1rem rgba(0,0,0,0.1);
    overflow-y hidden
    .nav-item
        width 33%
        text-align center
        flex-shrink  0
        font-size .34rem
        font-weight  bold
        height .34rem
        line-height @height
        // background-image:linear-gradient( #FFF 0%,#D8D8D8 50% ,#FFF 100%)
        background-size:1PX 100%;
        background-repeat no-repeat;
        background-position-x 99.9%
        // border-image: linear-gradient( #FFF 0%,#D8D8D8 50% ,#FFF 100%) 1 10 ;
        border-right: 1px solid #EAEAEA;
        position relative
        color: #CCCCCC
        ellipsis()
        &:last-child
          background-image: none
          border-right none
      &:last-child
        border-right none
    .choose_tag
      display none
      position absolute
      bottom 0
      width .6rem
      height .08rem
      background-image: linear-gradient(90deg, #F8DEA5 0%, #F7C772 100%);
      box-shadow: 0 6px 6px 0 rgba(252,216,151,0.34);
      border-radius: 5px;
      hcenter();
    .choose
      color: #F7C875 !important;
      .choose_tag
        // display block
  .cls_navbar_scroll
    overflow-x scroll
    -webkit-overflow-scrolling touch
    .nav-item
      width 20%



</style>
